import { useEffect } from 'react';
import styles from './scaffold.module.scss';

export const useJsEnabled = () => {
  useEffect(() => {
    const noJsElements = Object.assign({}, document.getElementsByClassName(styles.noJs));
    Object.values(noJsElements).forEach((element) => {
      element.classList.remove(styles.noJs);
    });
  }, []);
};
